// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { controlsContainerStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

controlsContainerStyles.controlsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
        gap: 32px;

        > div:first-child {
            width: auto;
            flex: 1;
        }

        ${xScreen("lt", "md")} {
            flex-direction: column;
            gap: 12px;
            flex-wrap: wrap;
        }
    `,
};
controlsContainerStyles.container = {
    css: css`
        ${xScreen("lte", "sm")} {
            min-height: 77px;
        }
    `,
};
controlsContainerStyles.viewSelectAndPaginationWrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 96px) 1fr;
        gap: 32px;
        align-items: center;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};
